import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import { FaMasksTheater, FaPeopleRoof, FaGraduationCap, FaTrophy, FaBuildingUser, FaBus } from "react-icons/fa6";
import { FaHeartbeat } from "react-icons/fa";
import { BiCategoryAlt } from "react-icons/bi";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { Link } from 'react-router-dom';
import ProjectGallery from '../components/ProjectGallery';
import LoadingSpinner from '../components/LoadingSpinner';
import useTitle from '../hooks/useTitle';
import './AboutPage.css';

// Маппинг иконок для секторов
const sectorIcons = {
    'culture': <FaMasksTheater className="icon" />,
    'social': <FaPeopleRoof className="icon" />,
    'education': <FaGraduationCap className="icon" />,
    'healthcare': <FaHeartbeat className="icon" />,
    'sport': <FaTrophy className="icon" />,
    'transport': <FaBus className="icon" />,
    'private': <FaBuildingUser className="icon" />,
    'other': <BiCategoryAlt className="icon" />
};

// Загрузка картинок для Webpack
function importAll(r) {
    return r.keys().map(r);
}
  
// Динамический импорт всех изображений из папки projects
const projectImages = importAll(require.context('../images/projects', false, /\.(png|jpe?g|svg)$/));

const About = () => {
    const { data: sectorsWithProjects, loading, error } = useSelector(state => state.sectorsWithProjects);
    const [expandedCategories, setExpandedCategories] = useState({});
    // Задаем название сайта
    useTitle('О компании');

    const toggleCategory = (categoryId) => {
        setExpandedCategories(prev => ({
            ...prev,
            [categoryId]: !prev[categoryId]  // Инвертируем состояние конкретной категории
        }));
    };

    // Преобразуем данные с API в формат, подходящий для компонента
    const formatSectorData = () => {
        if (!sectorsWithProjects || sectorsWithProjects.length === 0) return [];

        return sectorsWithProjects.map(sector => ({
            id: sector.id.toString(),
            name: sector.title,
            icon: sectorIcons[sector.name] || <BiCategoryAlt className="icon" />,
            projects: sector.projects.map(p => p.projectName)
        }));
    };

    const projectsData = formatSectorData();

    return (
        <Container className="about-page py-4">
            {/* Хлебные крошки */}
            <div className="breadcrumbs mb-3">
                <Link to="/">Главная</Link> {' > '} <span>О компании</span>
            </div>
            
            {/* Блок "О компании" */}
            <div className="projects-header">
                <h1 className="projects-title mb-3">О компании</h1>
                <p className="projects-subtitle mb-4">
                    В рамках реализации Федеральной программы «Доступная Среда» было <span className="highlighted fw-bold">комплексно оборудовано более 100</span> учреждений
                </p>
            </div>
    
            {loading ? 
                    <div className="spinner-container">
                        <LoadingSpinner message="Загрузка информации о проектах..."/>
                    </div> :
                error ? 
                    // <div className="alert alert-danger">
                    //     Произошла ошибка при загрузке проектов: {error}
                    // </div> 
                    null
                :
                <div className="projects-content mb-5">
                    <h2 className="categories-title mb-4">Реализованные проекты по категориям</h2>
                    
                    <Row className="categories-grid">
                        {projectsData.map((category) => (
                            <Col lg={6} className="mb-4" key={category.id}>
                                <div className={`category-card ${expandedCategories[category.id] ? 'expanded' : ''}`}>
                                    <div className="category-header" onClick={() => toggleCategory(category.id)}>
                                        <div className="category-icon">
                                            {category.icon}
                                        </div>
                                        <div className="category-info">
                                            <div className="category-name">{category.name}</div>
                                            <div className="category-count">Количество проектов <span className="count-badge">{category.projects.length}</span></div>
                                        </div>
                                        <div className="category-toggle">
                                            {expandedCategories[category.id] ? (
                                                <BsChevronUp className="toggle-icon" />
                                            ) : (
                                                <BsChevronDown className="toggle-icon" />
                                            )}
                                        </div>
                                    </div>
                                    
                                    {expandedCategories[category.id] && category.projects.length > 0 && (
                                        <div className="category-content">
                                            <ul className="project-list scrollable-list">
                                                {category.projects.map((project, idx) => (
                                                    <li key={idx}>{project}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            }
            {/* Блок "Галерея работ" */}
            <ProjectGallery 
                images={projectImages}
                title="Галерея выполненных работ"
                initialIndex={0}
                maxVisibleThumbnails={7}
            />
        </Container>
    );
};

export default About;